import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'


export type IRmaConfigDTO = {
  allow_all_products: boolean
  days_retour: number
  max_comment_length: number
  show_memo?: boolean
  show_memo2?: boolean
  show_memo3?: boolean
}


export class RmaConfigDTO {
  allowAllProducts: boolean
  daysRetour: number
  maxCommentLength: number
  showMemo: boolean
  showMemo2: boolean
  showMemo3: boolean

  constructor(data: IRmaConfigDTO) {
    this.allowAllProducts = data.allow_all_products
    this.daysRetour = data.days_retour
    this.maxCommentLength = data.max_comment_length
    // Optional: an older trydent may not send these yet. Missing means "not configured", so show the field.
    this.showMemo = data.show_memo ?? true
    this.showMemo2 = data.show_memo2 ?? true
    this.showMemo3 = data.show_memo3 ?? true
  }
}


const validate = createValidate<IRmaConfigDTO>()

export const parseRmaConfigDTO = (data: unknown): RmaConfigDTO => {
  validateGuard(validate, data, 'rma config')
  return new RmaConfigDTO(data)
}
